import { checkCookieConsent, consentToCookies } from "@/api/utils.js"

const state = {
  showCookieConsent: false,
  appCookieDomain: "",
  appCookieDomainVideoInHome: ""
}

const getters = {
  getShowCookieConsent: (state) => state.showCookieConsent,
  getAppCookieDomain: (state) => state.appCookieDomain,
  getAppCookieDomainVideoInHome: (state) => state.appCookieDomainVideoInHome,
}

const mutations = {
  setShowCookieConsent: (state, payload) => (state.showCookieConsent = payload),
  setAppCookieDomain: (state, payload) => (state.appCookieDomain = payload),
  setAppCookieDomainVideoInHome: (state, payload) => (state.appCookieDomainVideoInHome = payload),
}

const actions = {
  checkCookieConsent({ commit }) {
    const consentNeeded = !checkCookieConsent();
    commit("setShowCookieConsent", consentNeeded);
  },
  consentToCookies({ commit }) {
    consentToCookies();
    commit("setShowCookieConsent", false);
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
